import {ScrollArea as ScrollAreaPrimitive} from '@base-ui/react/scroll-area'
import {ReactNode} from 'react'

import {cn} from '@utilities/helpers'

type ScrollAreaProps = ScrollAreaPrimitive.Root.Props & {
    children: ReactNode
    scrollbar: ReactNode
    viewportProps?: ScrollAreaPrimitive.Viewport.Props
}

function ScrollArea({children, scrollbar, viewportProps, className, ...rest}: ScrollAreaProps) {
    return (
        <ScrollAreaPrimitive.Root className={cn('relative', className)} data-slot="scroll-area" {...rest}>
            <ScrollAreaPrimitive.Viewport
                data-slot="scroll-area-viewport"
                {...viewportProps}
                className={cn('size-full', viewportProps?.className)}
            >
                <ScrollAreaPrimitive.Content className="table w-full" data-slot="scroll-area-content">
                    {children}
                </ScrollAreaPrimitive.Content>
            </ScrollAreaPrimitive.Viewport>
            {scrollbar}
            <ScrollAreaPrimitive.Corner />
        </ScrollAreaPrimitive.Root>
    )
}

function Scrollbar({className, orientation = 'vertical', ...props}: ScrollAreaPrimitive.Scrollbar.Props) {
    return (
        <ScrollAreaPrimitive.Scrollbar
            className={cn(
                'flex touch-none bg-transparent opacity-0 transition-opacity duration-150 select-none data-hovering:opacity-100 data-scrolling:opacity-100 data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:flex-col data-[orientation=vertical]:w-1.5',
                className
            )}
            data-slot="scroll-area-scrollbar"
            orientation={orientation}
            {...props}
        >
            <ScrollAreaPrimitive.Thumb
                className="relative flex-1 rounded-[3px] bg-neutral-300 transition-colors duration-200 ease-in-out hover:bg-neutral-400"
                data-slot="scroll-area-thumb"
            />
        </ScrollAreaPrimitive.Scrollbar>
    )
}

export {ScrollArea, Scrollbar}
